import Document from '../document/Document.js';

/**
 * Document.
 */
export default class SVGDocument extends Document {}
